import React, { useEffect } from "react";
import Storage from "../services/storage.service";
import SimDeactivationAbsher from "../views/simDeactivation/sim-deactivation-absher";
import SimDeactivationStepper from "../views/simDeactivation/stepper";

export default function SimDeactivationAbsherUI(props) {
    const { history } = props;

    useEffect(() => {
        // Check if state exists in history.location and set the data accordingly
        if (history?.location?.state && history?.location?.state?.formValues) {
          const formValues = history?.location?.state?.formValues;
          // Extract the required values
          const normalizedData = {
              phone: formValues.phone.value,
              idType: formValues.idType.value,
              idNumber: formValues.idNumber.value,
              reason: formValues.deactivationReason.value,
              IBAN: formValues.IBAN.value,
              contact: formValues.contact.value,
          };
          Storage.set("simDeactivationData", JSON.stringify(normalizedData), true)
        }
    }, [history.location.state]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const stepsDetails = {
            step1: {
                // Number
                // Prepaid & Postpaid
              status: "isDone",
            },
            step2: {
                // OTP
                // Postpaid Only
              status: "isDone",
            },
            step3: {
                // Absher
                // PrePaid Only
              status: "inProgress",
            },
            step4: {
                // Payment
                // Postpaid Only
              status: "notVisited",
            },
            step5: {
                // Confirmation
                // Prepaid & Postpaid
              status: "notVisited",
            }
        };
        Storage.set("act_step_detail", stepsDetails)
    }, [])

	return (
		<div className="storefront-two-col-pg">
            <SimDeactivationAbsher {...props}/>
			<SimDeactivationStepper />
		</div>
	)
}